import { createFileRoute, Outlet, useMatchRoute } from '@tanstack/react-router'
import ScreenerPage from '@features/screener/components/ScreenerPage'
import { AutoBreadcrumb } from '@/components/ui/auto-breadcrumb'

export const Route = createFileRoute('/_authenticated/screener')({
  component: ScreenerPageRoute,
})

function ScreenerPageRoute() {
  const matchRoute = useMatchRoute()
  const isExactRoute = matchRoute({ to: '/screener' })

  // If we're on the exact /screener route (no assetId), show the screener page
  // Otherwise, render Outlet to allow child routes (like /screener/$assetId) to render
  if (isExactRoute) {
    return (
      <div className="p-3 md:p-6 space-y-4 md:space-y-6">
        <AutoBreadcrumb />
        <ScreenerPage />
      </div>
    )
  }

  return <Outlet />
}
